export default __webpack_public_path__ + "../images/rad-2.svg";